import React, { useEffect } from "react";
import PowerBi from "../admin/poc/PowerBi";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../redux/actions/menuActions";
import { connect } from "react-redux";
// import MenuAdmin from "../imports/Menu";

const Home = props => {
  useEffect(() => {
    props.setMenuTopIndex("dashboard");
    props.setMenuLeftIndex("home");
    props.setMenuLeftItemIndex("");
    props.setMenuLeftContent([]);
  }, []);
  return <PowerBi></PowerBi>;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    }
  };
};

export default connect(null, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// src/pages/dashboard/Home.js